import "slick-carousel";
export default () => {
  //Homepage - Hero Slider
  $(".block-hero-slider").slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    rows: 0,
    // adaptiveHeight: true
  });
}